import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { VideoLipsyncStatus } from '@packages/global';
import { useTranslation } from 'react-i18next';

interface SearchBarProps {
  searchTerm: string;
  statusFilter: VideoLipsyncStatus | '';
  onSearchTermChange: (term: string) => void;
  onStatusFilterChange: (status: VideoLipsyncStatus | '') => void;
}

export default function SearchBar({
  searchTerm,
  statusFilter,
  onSearchTermChange,
  onStatusFilterChange
}: SearchBarProps) {
  const { t } = useTranslation(['generation', 'common']);

  return (
    <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
      {/* 搜索框 */}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          className="block w-full pl-10 pr-3 py-2 border border-border-subtle rounded-md leading-5 bg-bg-form text-gray-50 placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
          placeholder={t('generation:lipsync.searchPlaceholder')}
        />
      </div>

      {/* 状态筛选 */}
      <select
        value={statusFilter}
        onChange={(e) => onStatusFilterChange(e.target.value as VideoLipsyncStatus | '')}
        className="border border-border-subtle rounded-md px-3 py-2 bg-bg-form text-gray-50 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
      >
        <option value="">{t('generation:lipsync.allStatus')}</option>
        {Object.values(VideoLipsyncStatus).map((value) => (
          <option key={value} value={value}>{t(`generation:status.${value}`)}</option>
        ))}
      </select>
    </div>
  );
}